<template>
  <div class="exp">
    <ul>
      <li
        :class="{ 'mos-imp' : mostImportant }"
        class="exp-item"
        :style="[
          expandable ? { cursor: 'pointer' } : { cursor: 'not-allowed' },
        ]"
        @click="expandTreeItem"
      >
        <b >{{ explanation.value }}  </b>
        {{ explanation.description }}
        <v-icon v-if="mostImportant">mdi-arrow-right-box</v-icon>
      </li>

      <ul v-if="isOpen">
        <TreeItem
          v-for="(child, index) in explanation.details"
          :key="index"
          :explanation="child"
          :desc="explanation.description"
          :parent-val="explanation.value"
          :status="status"
        />
      </ul>
    </ul>
  </div>
</template>

<script>
export default {
  data: function () {
    return {

      isOpen:false,
      expandable: this.explanation.details.length != 0,
    };
  },
  name: "TreeItem",
  props: ["explanation","desc","parentVal","status"],
  computed : {
    mostImportant() {
      if(this.$props.desc==null ||this.$props.parentVal == null ) { return true;}
      let val = this.$props.explanation.value;
      let pVal = this.$props.parentVal;
      let difference = pVal - val;
      
      if(this.$props.desc.includes("min of") || this.$props.desc.includes("max of")) {
        return val === pVal;
      }
      if(this.$props.desc.includes("product of")) {
        const temp = this.$parent.explanation.details;
        for(let v of temp) {
         
        if ((pVal - v.value) < difference ) { return false;}
        }
        return true;
        
      }
     return false;
      },
     
     
  
  },
   watch: {
    status: {
    
    immediate: true, 
    handler (val) {
      
     if(val.includes("openall")) {
           
          this.isOpen = true;
        }
         if(val.includes("bestpath")) {
           
          this.isOpen = this.mostImportant;
        }
           if(val.includes("closeall")) {
            
           this.isOpen = false;
        }
    }
  }
   },
  methods: {
    expandTreeItem: function () {
     
      this.isOpen = ! this.isOpen;
    },

  },
};
</script>

<style scoped>
.exp {
  width: 100%;
  height: auto;
}
ul {
  list-style-type: circle;
  padding-left: 8px !important;
 
}
.exp-item {
  position: relative;
  color: rgb(19, 22, 24);
  border: 1px solid rgba(48, 53, 56, 0.349);
  border-radius: 8px;
  padding: 6px;
  margin-bottom: 2px;
  width:fit-content;
  transition: all 0.1s ease-in-out;
}
.mos-imp{
   border: 3px solid  var(--primary) !important;
   
}
@media only screen and (max-width: 800px) {
  .exp-item {
    width: 100%;
  }
}
.exp-item .arrow {
  position: absolute;
  display: inline-block;
  right: -5px;
  top: 13px;
  width: 10px;
  display: inline-block;
  height: 10px;
  border: 1px solid black;
  transition: all 0.1s ease-in-out;
}
.exp-item:hover {
  border-color: rgb(68, 68, 68);
  color: rgb(63, 63, 63);
}
.exp-item:hover .arrow {
 
}
.exp-item:hover b {
  color: rgb(90, 90, 89) !important;
}
</style>